import React from "react"

import { Formik, Form, FieldArray, ErrorMessage } from "formik"
import * as yup from "yup"

import { Fieldset, Modal } from "components"
import { FieldPassenger } from "../Modals/Passengers"

const TODAY = new Date().toISOString()

const BookingInsurance = ({
  passengerFields,
  numberOfLodgings,
  isOpen,
  onClose,
  onSubmit,
}) => {
  const passengerModel = {
    relationship: "Primary",

    firstName: "",
    lastName: "",

    email: "",
    phone: "",

    gender: "",
    birthdate: "",

    street: "",
    city: "",
    state: "",
    zip: "",
    country: "USA",

    newsletter: true,
    // ...passengerMock,
  }

  const formikProps = {
    initialValues: {
      passengers: new Array(numberOfLodgings).fill().map((_, index) => {
        return {
          ...passengerModel,
          relationship: index === 0 ? "Primary" : "",
        }
      }),
    },
    validateOnBlur: false,
    validateOnChange: false,
    // validationSchema: userSchema,
    onSubmit: async (values, { props, resetForm, setErrors }) => {
      try {
        await onSubmit(values)
        // await onClose()
      } catch (error) {
        setErrors({ server: error?.graphQLErrors })
      }
    },
  }

  return (
    <Modal title="Add Insurance" isOpen={isOpen} onClose={onClose}>
      <div className="max-w-screen-lg mx-auto">
        <Formik {...formikProps}>
          {({ values, errors, isSubmitting }) => (
            <Form>
              <div className="w-full">
                <div className="w-full px-2 py-3">
                  {values?.passengers?.map((_, index) => (
                    <FieldPassenger
                      fields={passengerFields}
                      key={index}
                      index={index}
                    />
                  ))}
                  <ErrorMessage name="payment.deposits">
                    {(msg) =>
                      typeof msg === "string" && (
                        <div className="text-sm error bg-red-200 text-red-800 p-2 mt-2">
                          {msg}
                        </div>
                      )
                    }
                  </ErrorMessage>
                </div>
              </div>

              <div className="py-3">
                {errors?.server?.map(({ code, message }) => (
                  <div role="alert">
                    <div className="bg-red-500 text-white font-bold rounded-t px-4 py-2">
                      {code}
                    </div>
                    <div className="border border-t-0 border-red-400 rounded-b bg-red-100 px-4 py-3 text-red-700">
                      <p>{message}</p>
                    </div>
                  </div>
                ))}
              </div>

              <ModalNavigation {...{ isSubmitting, onClose }} />
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  )
}

export default BookingInsurance

const ModalNavigation = ({ isSubmitting, onClose }) => {
  return (
    <div className="px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
      <span className="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
        <button
          disabled={isSubmitting}
          type="submit"
          className="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green transition ease-in-out duration-150 sm:text-sm sm:leading-5 disabled:opacity-50 disabled:cursor-wait"
        >
          Save
        </button>
      </span>

      <span className="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
        <button
          onClick={onClose}
          type="button"
          className="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
        >
          Cancel
        </button>
      </span>
    </div>
  )
}
